const KEY = '?client_id=3PinzL1qMicgLrVfznb5ug8UQvnl60mugTe3UH_-hYU';
const URL = `https://api.unsplash.com/photos/`;

const IMAGES = {
    LOAD: 'IMAGES_LOAD',
    LOAD_SUCCESS: 'IMAGESE_lOAD_SUCCESS',
    LOAD_FAIL: 'IMAGES_LOAD_fAIL',
};

const STATS = {
    LOAD: 'STATS_LOAD',
    LOAD_SUCCESS: 'STATS_LOAD_SUCCESS',
    LOAD_FAIL: 'STATS_LOAD_FAIL',
};

export { KEY, URL, IMAGES, STATS };
